import Tooltip from '@mui/material/Tooltip';
import {withStyles} from "@mui/styles";
import Typography from "@mui/material/Typography";
import {apiFetch} from "../api/restClient";
import {gql} from "@apollo/client";
import React, {useState, useRef} from "react";
import Grid from "@mui/material/Grid";
import {Box} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {formatNumber} from "./invoices";
const defaultavatar = "/defaultavatar.png";

const getInvoiceMentionUrl = (tab, doc) => {
    const invoiceRef = doc?.invoiceUuid || doc?.invoiceId;
    if (!invoiceRef) {
        return `https://tool.click.fan/invoices/${tab}`;
    }
    return `https://tool.click.fan/invoices/${tab}?edit=${invoiceRef}`;
};

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const sendMessage = async (doc,
                                  token,
                                  type = 'pricechange',
                                  address = 'https://hooks.slack.com/services/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', //Olga
                                  // address = 'https://hooks.slack.com/services/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', //Christian
                                  message
) => {

    if (type === 'pricechange') {
        const
            textHead = `Channel:\t\t_${doc.channel}_\nCampaign:\t_${doc.campaign}_\nOwner:\t\t_${doc.owner}_\nChangedBy:\t\t_${doc.changedBy}_`,
            textBody = `Type:\t_${doc.priceWasChanged.type}_\nFrom:\t_$${doc.priceWasChanged.oldValue}_\nTo:\t\t_$${doc.priceWasChanged.newValue}_`;

        const form = {
            "text": `:argh: *${doc.text}*`,
            "attachments": [
                {
                    "text": textHead,
                    "color": "#2571e3",
                    "attachment_type": "default",
                },
                {
                    "text": textBody,
                    "color": "#e32525",
                    "attachment_type": "default",
                }
            ]
        };

        await sendSlackMessage(form, address, token);
    }

    if (type === 'opened') {
        const form = {
            "text": ":new: *New card created*",
            "attachments": [
                {
                    "text": `New card created: ${doc.metadata.name}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Card",
                            "type": "button",
                            "url": `https://tool.click.fan/cards?edit=${doc.metadata.campaignMetaId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'rfp') {
        const form = {
            "text": ":shrug: *New request for proposal*",
            "attachments": [
                {
                    "text": `New rfp: ${doc.metadata.name}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Card",
                            "type": "button",
                            "url": `https://tool.click.fan/cards?edit=${doc.metadata.campaignMetaId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'cardassignment') {
        const form = {
            "text": ":clipboard: *Card assigned*",
            "attachments": [
                {
                    "text": `You have been assigned to a card: ${doc.name}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Card",
                            "type": "button",
                            "url": `https://tool.click.fan/cards?edit=${doc.campaignMetaId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'commentmentioned') {
        const form = {
            "text": ":hash: *Mentioned in a card comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in a card comment: ${doc.name}\nMessage:\t${message}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Card",
                            "type": "button",
                            "url": `https://tool.click.fan/cards?edit=${doc.campaignMetaId}`
                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newCreativeComment') {
        const campaignId = doc?.campaignId;
        const creativeUuid = doc?.creativeUuid || doc?.invoiceUuid || doc?.invoiceId;
        const creativeUrl = campaignId
            ? `https://tool.click.fan/campaign/${campaignId}/creatives${creativeUuid ? `?editCreative=${creativeUuid}` : ''}`
            : 'https://tool.click.fan/campaigns';
        const titleParts = [
            doc?.channelName || doc?.invoiceName || 'Creative',
            doc?.campaignName,
        ].filter(Boolean);
        const form = {
            "text": ":mailbox: *Mentioned in a creative comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in a creative comment for ${titleParts.join(' / ')}:\nComment:\t${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "creative",
                            "text": "Show Creative",
                            "type": "button",
                            "url": creativeUrl,
                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'descriptionmentioned') {
        const form = {
            "text": ":hash: *Mentioned in a card description*",
            "attachments": [
                {
                    "text": `You have been mentioned in a card description: ${doc.name}\nMessage:\t${message}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Card",
                            "type": "button",
                            "url": `https://tool.click.fan/cards?edit=${doc.campaignMetaId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newVacationsComment') {
        const form = {
            "text": ":mailbox: *Mentioned in a vacation request comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in an vacation request comment: ${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "invoice",
                            "text": "Show Vacation Request",
                            "type": "button",
                            "url": `https://tool.click.fan/my-jmg?tab=vacations&vacation=${doc.invoiceId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newSupplyInvoiceComment') {
        const form = {
            "text": ":mailbox: *Mentioned in an invoice comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in a comment for an invoice:\nName:\t${doc.invoiceName}\nComment:\t${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "invoice",
                            "text": "Show Invoice",
                            "type": "button",
                            "url": getInvoiceMentionUrl('supply', doc)

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newDemandInvoiceComment') {
        const form = {
            "text": ":mailbox: *Mentioned in an invoice comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in a comment for an invoice:\nName:\t${doc.invoiceName}\nComment:\t${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "invoice",
                            "text": "Show Invoice",
                            "type": "button",
                            "url": getInvoiceMentionUrl('demand', doc)

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newOperationsInvoiceComment') {
        const form = {
            "text": ":mailbox: *Mentioned in an invoice comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in an invoice comment:\nName:\t${doc.invoiceName}\nComment:\t${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "invoice",
                            "text": "Show Invoice",
                            "type": "button",
                            "url": getInvoiceMentionUrl('operations', doc)

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newVacationsComment') {
        const form = {
            "text": ":mailbox: *Mentioned in a vacation request comment*",
            "attachments": [
                {
                    "text": `You have been mentioned in an vacation request comment: ${doc.comment}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "invoice",
                            "text": "Show Vacation Request",
                            "type": "button",
                            "url": `https://tool.click.fan/my-jmg?tab=vacations&vacation=${doc.invoiceId}`

                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'missingSignedContractFile') {
        const form = {
            "text": ":page_with_curl: *Missing signed contract file*",
            "attachments": [
                {
                    "text": `We are missing a signed contract file for *${doc.channelName}* in ${doc.campaignName}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "creative",
                            "text": "Show Creative",
                            "type": "button",
                            "url": doc?.campaignId
                                ? (doc?.creativeId
                                    ? `https://tool.click.fan/campaign/${doc.campaignId}/creatives?editCreative=${doc.creativeId}`
                                    : `https://tool.click.fan/campaign/${doc.campaignId}/creatives`)
                                : "https://tool.click.fan/campaigns"
                        }
                    ]
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }

    if (type === 'newCard') {
        const dueDateText = doc.dueDate !== '' ? `Due ${doc.dueDate}` : 'No due date informed';
        const form = {
            text: ":new: *New Card created*",
            attachments: [
                {
                    text: `*${doc.who}* created a new card: *${doc.cardName}*. ${dueDateText}.`,
                    color: "#3AA3E3",
                    attachment_type: "default",
                    ...(doc.cardUrl && {
                        actions: [
                            {
                                name: "view-card",
                                text: "View Card",
                                type: "button",
                                url: doc.cardUrl
                            }
                        ]
                    })
                }
            ]
        };
        await sendSlackMessage(form, address, token);
    }
};

export const storeChannel = (data, token, method = 'POST') => new Promise((resolve, reject) => {

    const reqOptions = {
        method,
        token,
        body: data,
    };

    apiFetch(`/channel/`, reqOptions)
        .then(resolve)
        .catch(reject);
});

export const sendSlackMessage = async (form, address, token) => {
    // console.log(form, address, token);
    // return;
    await apiFetch(
        `/creative/sendSlackMessage/`,
        {
            method: 'post',
            body: {form, address},
            token,
        })
        .catch(err => console.log(err))
}

export const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        zIndex: 202020202,
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        // fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

export const FillRing = ({ value }) => {
    const n = Number(value);
    if (!isFinite(n)) return "";

    const clamped = Math.max(0, Math.min(100, n));
    const over = n > 100 ? n - 100 : 0;

    const label = over > 0 ? `Fill: ${formatNumber(n, 0)} % (+${formatNumber(over, 0)} %)` : `Fill: ${formatNumber(n, 0)} %`;

    return (
        <Tooltip title={label}>
            <Box sx={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                <CircularProgress
                    variant="determinate"
                    value={clamped}
                    color="info"
                    size={40}
                    thickness={3.6}
                    sx={{ transform: "rotate(-90deg)" }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 800 }}>
                        {formatNumber(n, 0)}
                    </Typography>
                </Box>
            </Box>
        </Tooltip>
    );
};

export const HoverText = ({text, component, placement}) => {

    return (
        <>
            <HtmlTooltip
                arrow
                placement={placement || 'left-start'}
                title={
                    <>
                        {component}
                    </>
                }
            >
                <Typography>
                    {text}
                </Typography>
            </HtmlTooltip>
        </>
    )
}

const decodeHtmlEntities = (value) => {
    if (typeof document === 'undefined') return value;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
};

const normalizeCommentText = (value) => {
    if (!value) return '';

    return decodeHtmlEntities(String(value)
        .replace(/<span class="mention"[^>]*>@([^<]+)<\/span>/gi, '@[$1]($1)')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
        .replace(/<\/?p[^>]*>/gi, '')
        .replace(/<li[^>]*>/gi, '- ')
        .replace(/<\/li>/gi, '\n')
        .replace(/<\/?ul[^>]*>/gi, '')
        .replace(/<[^>]+>/g, ''));
};

const renderCommentText = (value) => {
    const text = normalizeCommentText(value);
    const mentionRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = mentionRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }

        parts.push(
            <Box
                component="span"
                key={`mention-${match.index}-${match[2]}`}
                sx={{
                    bgcolor: '#B79BFF66',
                    borderRadius: '2px',
                    px: '2px',
                    color: 'inherit',
                }}
            >
                {match[1]}
            </Box>
        );

        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts.length ? parts : text;
};

export const commentsView = (comments, userAssets, version = 1) => {
    if (!comments) return null;

    const reverseComments = (Object.assign([], comments)).reverse();
    return reverseComments.map((comment, i) => (
        <Grid container spacing={2} key={`comment${i}`}>
            <Grid item xs={1}>
                <img
                    src={userAssets ? userAssets[comment.who]?.photoUrl : defaultavatar}
                    alt={''}
                    referrerPolicy={"no-referrer"}
                    width={'28px'}
                    height={'28px'}
                    style={{
                        borderRadius: '25em',
                        objectFit: 'cover',
                        margin: '0px 0px 4px 32px'
                    }}
                />
            </Grid>
            <Grid item xs={11}>
                <Grid item xs={12}>
                    <Typography>
                        <strong>{comment.who}</strong><i> {formatDate(comment.when, true)}</i>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            border: (theme) => `1px solid ${theme.palette.divider}`,
                            borderRadius: 1,
                            px: 1.5,
                            py: 1,
                            minHeight: 40,
                            color: 'text.primary',
                            overflowWrap: 'anywhere',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        <Typography component="div" variant="body2" sx={{whiteSpace: 'pre-wrap'}}>
                            {renderCommentText(comment.what)}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    ));
};

export const formatNumbers = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
};

export const formatDate = (date, options = {}) =>
    new Date(date).toLocaleString(navigator.language, {
        dateStyle: 'medium',
        ...options
    });

export const truncateOneLine = (s = "", max = 42) => {
    const str = String(s || "").trim();
    if (!str) return "Invoice";
    return str.length > max ? `${str.slice(0, max - 1)}…` : str;
};

export const getISODateString = (date, ymd = false) => {
    if (!date) return '';
    const newDate = new Date(date);
    return ymd ?
        `${newDate.getFullYear()}-${(newDate.getMonth() + 1).toString().padStart(2, '0')}-${newDate.getDate().toString().padStart(2, '0')}` :
        `${newDate.getFullYear()}-${(newDate.getMonth() + 1).toString().padStart(2, '0')}`
};

export const getCurrentStats = (channelId, apiToken, showShorts = false) => new Promise((resolve, reject) => {

    const url = `/channelStats/getStats/channel/%2Fchannel%2F${channelId}/${showShorts ? 'SH' : 'LF'}`;

    apiFetch(url, {
        method: 'GET',
        token: apiToken,
    })
        .then(resolve)
        .catch(reject);

});

export const cpmMaxViews = (allViews, startDate, runTime, fixcpmLimit = 0) => { // works for CPM and FIX+ deal models

    const maxDate = new Date(new Date(startDate).getTime() + ((1000 * 3600 * 24) * (runTime)) - 1);
    const maxDay = `${maxDate.getFullYear()}-${maxDate.getMonth() + 1}-${maxDate.getDate()}`;

    return allViews ? allViews[maxDay] ? allViews[maxDay] - fixcpmLimit : Object.values(allViews).pop() - fixcpmLimit : 0;

};

export const demandPayout = (demand, views, startDate, uuid, estimatedViews, partnerCreative) => { // we do a prototype for a special Plarium Deal!

    if (demand?.model === 'fix')
        return parseFloat(demand?.maxPayout ? demand.maxPayout : 0);

    if (demand?.model === 'fixplus') {

        const specialUuid1 = 'coBUoh9kcQAQqyY99Mvp54'
        // const specialUuid2 = 'xne2kgaZ1xdYc1oa3RozN4'
        if (uuid === specialUuid1) {
            const totalViews = estimatedViews + partnerCreative.offer?.estimatedViews || 0
            const dViews = totalViews - demand.fixcpmLimit;
            const calculatedPayout = totalViews < demand.fixcpmLimit ?
                demand.maxPayout : ((dViews / 1000) * demand.payout) + demand.maxPayout;
            return demand.totalCap < calculatedPayout ?
                demand.totalCap :
                calculatedPayout;
        }

        const totalViews = cpmMaxViews(views, startDate, demand?.runTime) || 1;
        // console.log(totalViews)
        const dViews = cpmMaxViews(views, startDate, demand?.runTime, demand.fixcpmLimit);
        // console.log(dViews)
        const calculatedPayout = totalViews < demand.fixcpmLimit ?
            demand.maxPayout : ((dViews / 1000) * demand.payout) + demand.maxPayout;
        // console.log(calculatedPayout, demand.totalCap)
        return demand.totalCap < calculatedPayout ?
            demand.totalCap :
            calculatedPayout;
        // parseFloat(calculatedPayout.toFixed(2));
    }

    // else CPM deal model
    const dViews = cpmMaxViews(views, startDate, demand?.runTime)
    const demandPayout = (dViews / 1000) * demand?.payout;
    return demandPayout > demand?.maxPayout ?
        demand?.maxPayout : demandPayout < demand?.minPayout ?
            demand?.minPayout :
            demandPayout;
    // parseFloat(demandPayout.toFixed(2));
};

export const supplyPayout = (supply, views, startDate, uuid, estimatedViews, partnerCreative) => { // works only fine for USD currency ToDo
    {

        if (supply?.model === 'fix') // non CPM deals get the maxPayouts always. Thats why I used that field for FIX deals
            return parseInt(supply?.maxPayout ? supply.maxPayout : 0);

        if (supply?.model === 'fixplus') {

            const specialUuid1 = 'coBUoh9kcQAQqyY99Mvp54'
            // const specialUuid2 = 'xne2kgaZ1xdYc1oa3RozN4'
            if (uuid === specialUuid1) {
                // partnerCreative is unpaid and helps to get the promised views (e.g makegood videos)
                const totalViews = estimatedViews + partnerCreative?.offer?.estimatedViews || 0
                const sViews = totalViews - supply.fixcpmLimit;
                const calculatedPayout = totalViews < supply.fixcpmLimit ?
                    supply.maxPayout : ((sViews / 1000) * supply.payout) + supply.maxPayout;
                return supply.totalCap < calculatedPayout ?
                    supply.totalCap :
                    calculatedPayout;
            }

            const totalViews = cpmMaxViews(views, startDate, supply?.runTime);
            // console.log(totalViews)
            const sViews = cpmMaxViews(views, startDate, supply?.runTime, supply.fixcpmLimit);
            // console.log(sViews)
            const calculatedPayout = totalViews < supply.fixcpmLimit ?
                supply.maxPayout : ((sViews / 1000) * supply.payout) + supply.maxPayout;
            return supply.totalCap < calculatedPayout ?
                supply.totalCap :
                calculatedPayout;
        }

        // else CPM deal model
        const sViews = cpmMaxViews(views, startDate, supply?.runTime)
        const supplyPayout = (sViews / 1000) * supply?.payout;
        return supplyPayout > supply?.maxPayout ?
            supply?.maxPayout :
            supplyPayout < supply?.minPayout ?
                supply?.minPayout :
                supplyPayout;
    }
}

export const supPayout = creative => supplyPayout(creative.supply, creative.views, creative.startDate, creative.uuid, creative.offer.estimatedViews)

const deepObject = (source) => {
    const result = {}
    Object.keys(source).forEach((key) => {
        const value = source[key]
        result[key] = deepCopy(value)
    }, {})
    return result;
};

const deepArray = (collection) => {
    return collection.map((value) => {
        return deepCopy(value)
    })
};

export const deepCopy = (value) => {
    if (typeof value !== 'object' || value === null) {
        return value
    }
    if (Array.isArray(value)) {
        return deepArray(value)
    }
    return deepObject(value)
};

// sharedEmployeeLoadHelpers.js (oder oben in beiden Files einfügen)

// Status, die als "aktiv" für KPIs & Markup gelten
export const ACTIVE_STATUSES_FOR_KPI = ['selected', 'negotiation', 'offer', 'releaseplan', 'contract', 'signed'];

// Creatives eines Mitarbeiters aus campaignMetas aufbauen
export const buildEmployeeCreativesFromMetas = (campaignMetas, nickname) => {
    if (!campaignMetas) return [];

    return campaignMetas
        ?.filter(card => card.campaigns?.length > 0)
        .reduce((acc, card) => {
            const fromCard = card.campaigns
                .filter(
                    camp =>
                        camp.creatives?.length > 0 &&
                        (camp.shares.includes(nickname) || camp.owner === nickname)
                )
                .reduce((innerAcc, camp) => {
                    const mapped = camp.creatives
                        .filter(item => item.accountManager === nickname)
                        .map(creative => ({
                            ...creative,
                            card: card.name,
                            cardState: card.state,
                            cardId: card.campaignMetaId || card._id || null,
                            campaign: camp.name,
                            campaignId: camp._id || camp.campaignId || null,
                            country: camp.countryCode,
                            owner: creative.accountManager,
                        }));
                    return innerAcc.concat(mapped);
                }, []);
            return acc.concat(fromCard);
        }, [])
        .map(creative => ({
            id: creative.uuid,
            uuid: creative.uuid,
            card: creative.card,
            cardState: creative.cardState,
            cardId: creative.cardId,
            campaign: creative.campaign,
            campaignId: creative.campaignId,
            country: creative.country,
            influencerName: creative.channel?.name,
            platform: creative.type,
            adType: creative.format,
            status: creative.state,
            owner: creative.owner,
            supply: creative.supply,
            demand: creative.demand,
            offer: creative.offer,
            contractSigned:
                creative.status === 'released' || creative.status === 'signed',
            supplyPrice: creative.supply?.maxPayout,
            demandPrice: creative.demand?.maxPayout,
            earliestRelease: creative.earliestRelease || null,
            latestRelease: creative.latestRelease || null,
            releaseDate: creative.startDate || null,
            views: creative.views || null,
            clicks: creative.clicks || null,
        }));
};

// KPI-Berechnung – nur aktive Status, nur Creatives mit Supply & Demand für Markup
export const getKpisForCreatives = (creatives) => {
    const list = creatives || [];
    const totalCreatives = list.length;

    const activeCreatives = list.filter(c =>
        ACTIVE_STATUSES_FOR_KPI.includes(c.status)
    );
    const activeCreativesCount = activeCreatives.length;

    const activeCampaigns = new Set(activeCreatives.map(c => c.campaign)).size;

    const plannedReleases = activeCreatives.filter(c =>
        ['releaseplan', 'signed'].includes(c.status)
    ).length;

    let supplySum = 0;
    let demandSum = 0;

    activeCreatives.forEach(item => {
        if (!item.supply || !item.demand) return;

        const scost = supplyPayout(
            item.supply,
            null,
            null,
            item.uuid,
            item.offer?.estimatedViews
        );
        const dcost = demandPayout(
            item.demand,
            null,
            null,
            item.uuid,
            item.offer?.estimatedViews
        );

        if (!scost || !dcost) return;

        supplySum += scost;
        demandSum += dcost;
    });

    const markup = supplySum
        ? Math.round((demandSum * 100) / supplySum - 100)
        : 0;

    const loadScore = Math.min(
        100,
        activeCreativesCount * 7 + plannedReleases * 3
    );

    return {
        totalCreatives,
        activeCreativesCount,
        activeCampaigns,
        plannedReleases,
        loadScore,
        markup,
    };
};

export const getStateStyle = (theme, state) => {
    const mode = theme.palette.mode;

    const pick = (key) => {
        if (key === "grey") return theme.palette.grey[mode === "dark" ? 700 : 400];
        return theme.palette[key]?.main || theme.palette.primary.main;
    };

    const paletteKeyByState = {
        opened: "info",
        mediaplan: "warning",
        clientfeedback: "secondary",
        rollingout: "success",
        report: "primary",
        toinvoice: "warning",
        finished: "success",
        onhold: "grey",
        lost: "error",
        deleted: "grey",
    };

    const key = paletteKeyByState[state] || "primary";
    const main = pick(key);

    const bg =
        mode === "dark"
            ? theme.palette.action.hover
            : theme.palette.action.selected;

    return {
        borderColor: main,
        color: main,
        backgroundColor: bg,
    };
};

export const GET_DASHBOARD_REPORTING = gql`
    query GetDashboardReporting{
        dashboardReporting
    }
`;

export const GET_SUPPLY_INVOICES = gql`
    query GetSupplyInvoices($input: SupplyInvoicesOptions){
        supplyInvoices(input: $input) 
    }
`;

export const GET_SUPPLY_INVOICES_SUMMARY = gql`
    query GetSupplyInvoicesSummary($input: SupplyInvoicesOptions){
        supplyInvoicesSummary(input: $input)
    }
`;

export const GET_INVOICES = gql`
    query GetInvoices($input: InvoicesOptions){
        allInvoices(input: $input) 
    }
`;

export const REGION_CODES = new Set(["LATAM", "APAC", "EMEA", "DACH", "CEE", "SEA", "ANZ", "BENELUX", "GLOBAL", "INTL", "NAN", "NONE",]);
export const lanes = ['opened', 'mediaplan', 'clientfeedback', 'rollingout', 'report', 'toinvoice', 'finished', 'onhold', 'lost'];
export const currentYear = (new Date()).getFullYear();

export const UPDATE_CAMPAIGNMETA = gql`
    mutation UpdateCampaignMeta($input: CampaignMetaUpdateInput!) {
        updateCampaignMeta(input: $input) {
            _id
            name
            type
            types
            campaignMetaId
            owner
            supplyProjectLead
            date
            dueDate
            withDueTime
            countries
            description
            briefing
            attachments
            shares
            state
            position
            coarseBudget
            ioBudget
            invoices {
                _id
                uuid
                campaignMetaId
                acceptanceState {
                    stepZeroStarted
                    stepOneCorrect
                    stepTwoAmApproved
                    stepThreeAdminApproved
                    stepFourPaid
                }
                number
                invoiceText
                invoiceType
                attachments
                reminder
                name
                email
                address
                dateSent
                datePaid
                dueDate
                amount
                prepayment
                type
                channelId
                otherChannels
                campaignName
                state
                totalAmount
                partiallyAmount
                isStreamNinja
                contractor
                currency
                accountManager
                selectedCampaigns
            }
            cardComment
            comments {
                who
                when
                what
            }
            history {
                who
                when
                what
            }
            client {
                _id
                name
                domain
                accountManager
                vat
                costCenter
            }
            product {
                _id
                name
                domain
            }
            campaigns {
                _id
                campaignId
                state
                name
                owner
                shares
                countryCode
                date
                creatives {
                    _id
                    uuid
                    channel {
                        name
                        channelId
                    }
                    demand {
                        maxPayout
                    }
                    state
                    startDate
                    invoicing {
                        status
                        demandInvoices
                        notes {
                            invoice
                            payment
                            note
                        }
                    }
                }
            }
        }
    }
`;
export const CREATE_CAMPAIGNMETA = gql`
    mutation CreateCampaignMeta($input: CampaignMetaInput!) {
        createCampaignMeta(input: $input) {
            _id
            name
            type
            types
            campaignMetaId
            owner
            supplyProjectLead
            date
            dueDate
            withDueTime
            countries
            description
            briefing
            attachments
            shares
            state
            position
            coarseBudget
            ioBudget
            invoices {
                _id
                uuid
                campaignMetaId
                acceptanceState {
                    stepZeroStarted
                    stepOneCorrect
                    stepTwoAmApproved
                    stepThreeAdminApproved
                    stepFourPaid
                }
                number
                invoiceText
                invoiceType
                attachments
                name
                email
                address
                dateSent
                datePaid
                dueDate
                amount
                prepayment
                type
                channelId
                otherChannels
                campaignName
                state
                totalAmount
                partiallyAmount
                isStreamNinja
                contractor
                currency
                accountManager
            }
            cardComment
            comments {
                who
                when
                what
            }
            history {
                who
                when
                what
            }
            client {
                _id
                name
                domain
                accountManager
                vat
                costCenter
            }
            product {
                _id
                name
                domain
            }
            campaigns {
                _id
                campaignId
                state
                name
                owner
                shares
                countryCode
                date
            }
        }
    }
`;
export const GET_ALL_CAMPAIGN_META = gql`
    query GetCampaignMetas($options: CampaignMetaOptions){
        campaignMetas(options: $options) {
            _id
            name
            entity
            type
            types
            campaignMetaId
            owner
            supplyProjectLead
            date
            years
            dueDate
            withDueTime
            countries
            description
            briefing
            attachments
            shares
            state
            position
            coarseBudget
            ioBudget
            invoices {
                _id
                uuid
                campaignMetaId
                acceptanceState {
                    stepZeroStarted
                    stepOneCorrect
                    stepTwoAmApproved
                    stepThreeAdminApproved
                    stepFourPaid
                }
                number
                contractor
                invoiceText
                invoiceType
                attachments
                name
                email
                address
                dateSent
                datePaid
                dueDate
                amount
                prepayment
                type
                channelId
                otherChannels
                campaignName
                state
                totalAmount
                partiallyAmount
                isStreamNinja
                currency
                accountManager
            }
            cardComment
            comments {
                who
                when
                what
            }
            history {
                who
                when
                what
            }
            client {
                _id
                name
                domain
                accountManager
                vat
                costCenter
                contacts {
                    name
                    address
                    position
                    mail
                    phone
                }
            }
            product {
                _id
                name
                domain
                productImage
            }
            campaigns {
                _id
                campaignId
                state
                owner
                shares
                countryCode
                date
                name
                creatives {
                    _id
                    uuid
                    name
                    type
                    costAmount {
                        value
                        currency
                    }
                    channel {
                        name
                        channelId
                    }
                    supply {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    demand {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    views
                    state
                    startDate
                    format
                    invoicing {
                        status
                        demandInvoices
                        notes {
                            invoice
                            payment
                            note
                        }
                    }
                }
            }
        }
    }
`;
export const GET_DASHBOARD_CAMPAIGN_META_STATES = gql`
    query GetDashboardCampaignMetaStates($options: CampaignMetaOptions){
        dashboardCampaignMetas(options: $options) {
            _id
            campaignMetaId
            name
            owner
            date
            dueDate
            countries
            state
            client {
                name
            }
            product {
                name
            }
            campaigns {
                _id
                campaignId
                name
                countryCode
                date
            }
        }
    }
`;
export const GET_CARDBOARD_CAMPAIGN_META = gql`
    query GetCampaignMetas($options: CampaignMetaOptions){
        campaignMetas(options: $options) {
            attachments
            name
            description
            briefing
            entity
            campaignMetaId
            date
            cardComment
            comments {
                who
                when
                what
            }
            dueDate
            state
            types
            type
            owner
            supplyProjectLead
            shares
            countries
            invoices {
                _id
                uuid
                campaignMetaId
                acceptanceState {
                    stepZeroStarted
                    stepOneCorrect
                    stepTwoAmApproved
                    stepThreeAdminApproved
                    stepFourPaid
                }
                number
                contractor
                invoiceText
                invoiceType
                attachments
                reminder
                name
                email
                address
                dateSent
                datePaid
                dueDate
                amount
                prepayment
                datevBooked
                netTarget
                performancePeriod
                type
                channelId
                otherChannels
                campaignName
                state
                totalAmount
                partiallyAmount
                isStreamNinja
                currency
                accountManager
                selectedCampaigns
                comments {
                    who
                    when
                    what
                }
                history {
                    who
                    when
                    what
                }
            }
            product {
                _id
                name
                domain
                productImage
            }
            client {
                _id
                name
                domain
                accountManager
                vat
                costCenter
                contacts {
                    name
                    address
                    position
                    mail
                    phone
                }
            }
            campaigns {
                _id
                campaignId
                state
                name
                owner
                shares
                countryCode
                date
                creatives {
                    _id
                    uuid
                    name
                    type
                    accountManager
                    costAmount {
                        value
                        currency
                    }
                    channel {
                        name
                        channelId
                    }
                    supply {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    demand {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    views
                    state
                    startDate
                    format
                    invoicing {
                        status
                        demandInvoices
                        notes {
                            invoice
                            payment
                            note
                        }
                    }
                }
            }
        }
    }
`

export const GET_TEAMLOAD_CAMPAIGN_META = gql`
    query GetTeamLoadCampaignMetas($options: CampaignMetaOptions){
        teamLoadCampaignMetas(options: $options) {
            campaignMetaId
            name
            state
            shares
            campaigns {
                _id
                campaignId
                owner
                shares
                name
                countryCode
                creatives {
                    uuid
                    type
                    accountManager
                    channel {
                        name
                        channelId
                    }
                    supply {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    demand {
                        model
                        payout
                        minPayout
                        maxPayout
                        runTime
                        fixcpmLimit
                        totalCap
                    }
                    state
                    startDate
                    format
                }
            }
        }
    }
`

// NOTE: Slim query for Supply Project Tracker
export const GET_SUP_TRACKER_CAMPAIGN_META = gql`
    query GetSupTrackerCampaignMetas($options: CampaignMetaOptions) {
        campaignMetas(options: $options) {
            campaignMetaId
            name
            dueDate
            state
            countries
            cardComment
            comments {
                who
                when
                what
            }
            campaigns {
                owner
                shares
            }
        }
    }
`;

export const GET_HOT_CARDS = gql`
    query GetHotCards{
        hotCards
    }
`;
